import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

const NumberOfRatings = styled.span`
  ${fonts.helvetica['53-extended']};
  font-size: 15px;
  margin-left: 2px;
`;

const Stars = styled.div<{ isZero: boolean; centered: boolean; removeMargins: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.centered ? 'center' : 'unset')};

  ${({ isZero }) =>
    isZero
      ? css`
          opacity: 0;
        `
      : null};

  ${({ removeMargins }) =>
    removeMargins
      ? css`
          margin: 0;
        `
      : css`
          margin-bottom: 8px;
          margin-top: 8px;

          @media ${from(Device.Tablet)} {
            margin-bottom: 16px;
            margin-top: 8px;
          }
        `}
`;

const StarWrapper = styled.span<{ active: boolean }>`
  display: block;
  margin-right: 2px;

  &:last-child {
    margin-right: 0px;
  }

  svg {
    width: 14px;
    height: 14px;
    color: ${({ active }) => (active ? brand.red.base : brand.grey['85'])};
  }
`;

export const RatingStarsStyles = {
  Stars,
  StarWrapper,
  NumberOfRatings,
};
